import React from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { getRoleConfig } from 'common-src/features/auth';
import { isFeatureEnabled } from 'common-src/models/FeatureFlag';

import MasterDetailLayout from 'src/components/navigation/MasterDetailLayout';
import {
  DetailSection,
  MasterSection,
} from 'src/components/navigation/MasterDetailLayout/sections';
import {
  AthenaScreen,
  CallsScreen,
  CorrespondenceCopyScreen,
  FeatureFlagsScreen,
  MyAccountScreen,
  ScheduledMessagesScreen,
  UnassignedVisitsScreen,
} from 'src/components/screens';
import AvatarPlaceholder from 'src/components/widgets/AvatarPlaceholder';
import { saveSettingsTabInfo } from 'src/features/tabsState';
import useCustomSelector from 'src/hooks/useCustomSelector';
import useDocumentTitle from 'src/hooks/useDocumentTitle';
import usePathSelector from 'src/hooks/usePathSelector';

import styles from './Settings.module.scss';
import SettingsNav from './SettingsNav';

const Settings = () => {
  const dispatch = useDispatch();
  const canEditPlatformSettings = useCustomSelector(
    (state) => getRoleConfig(state).canEditPlatformSettings,
  );
  const canManageVisits = useCustomSelector((state) => getRoleConfig(state).canManageVisits);
  const isAthenaEnabled = useCustomSelector((state) => isFeatureEnabled(state, 'athena'));
  useDocumentTitle('Account Details');
  usePathSelector((path) => dispatch(saveSettingsTabInfo(path)));

  return (
    <article>
      <header className={[styles.header, 'vertically-centered'].join(' ')}>
        Edit account information and preferences
      </header>
      <MasterDetailLayout classNames={[styles.settings]}>
        <MasterSection classNames={[styles.aside]}>
          <SettingsNav
            canEditPlatformSettings={canEditPlatformSettings}
            canManageVisits={canManageVisits}
            isAthenaEnabled={isAthenaEnabled}
          />
        </MasterSection>
        <DetailSection classNames={[styles.section]}>
          <Routes>
            <Route path="/">
              <Route index element={<AvatarPlaceholder text="Select a Section" />} />
              <Route path="my-account" element={<MyAccountScreen />} />
              {canEditPlatformSettings && (
                <>
                  <Route path="feature-flags" element={<FeatureFlagsScreen />} />
                  <Route path="correspondence-copy" element={<CorrespondenceCopyScreen />} />
                </>
              )}
              <Route path="calls" element={<CallsScreen />} />
              <Route path="scheduled-messages" element={<ScheduledMessagesScreen />} />
              {isAthenaEnabled && <Route path="athena" element={<AthenaScreen />} />}
              {canManageVisits && (
                <Route path="unassigned-visits" element={<UnassignedVisitsScreen />} />
              )}
            </Route>
          </Routes>
        </DetailSection>
      </MasterDetailLayout>
    </article>
  );
};

export default Settings;
